import { WebPlugin } from '@capacitor/core';
export class CIDPrintWeb extends WebPlugin {
    constructor() {
        super({
            name: 'CIDPrint',
            platforms: ['web'],
        });
    }
    enableDebugToFile(options) {
        console.log('enableDebugToFile', options);
        throw new Error('Method not implemented.');
    }
    enableClipping(options) {
        console.log('enableClipping', options);
        throw new Error('Method not implemented.');
    }
    showNavigationBar(options) {
        console.log('showNavigationBar', options);
        throw new Error('Method not implemented.');
    }
    isBluetoothAdapterEnabled() {
        throw new Error('Method not implemented.');
    }
    isLibraryInitialized() {
        throw new Error('Method not implemented.');
    }
    enableCalibration(options) {
        console.log('enableCalibration', options);
        throw new Error('Method not implemented.');
    }
    sendFormFeed() {
        throw new Error('Method not implemented.');
    }
    requestPermission(options) {
        console.log('requestPermission', options);
        throw new Error('Method not implemented.');
    }
    requestAllPermissions(options) {
        console.log('requestAllPermissions', options);
        throw new Error('Method not implemented.');
    }
    enableBluetoothAdapter(options) {
        console.log('enableBluetoohAdapter', options);
        throw new Error('Method not implemented.');
    }
    getMediaSize() {
        throw new Error('Method not implemented.');
    }
    getPrinterLibraryVersion() {
        throw new Error('Method not implemented.');
    }
    getPrinterInformation() {
        throw new Error('Method not implemented.');
    }
    getLatestConnectState() {
        throw new Error('Method not implemented.');
    }
    uploadFile(options) {
        console.log('uploadFile', options);
    }
    async printLabelWithObject(options) {
        console.log('printLabelWithObject', options);
        return { value: 'printLabelWithObject' };
    }
    async printReceiptWithObject(options) {
        console.log('printReceiptWithObject', options);
        return { value: 'printReceiptWithObject' };
    }
    async printLabelWithData(options) {
        console.log('printLabelWithData', options);
        return { value: 'printLabelWithData' };
    }
    async printLabel(options) {
        console.log('printLabel', options);
        return { value: 'printLabel' };
    }
    async connectToPreferredPrinter(options) {
        console.log('connectToPreferredPrinter', options);
        return { value: 'connectToPreferredPrinter' };
    }
    async connectToPrinter(options) {
        console.log('connectToPreferredPrinter', options);
        return { value: 'connectToPreferredPrinter' };
    }
    disconnectFromPrinter(options) {
        console.log('disconnectFromPrinter', options);
    }
    initCIDPrinterLib() {
        throw new Error('Method not implemented.');
    }
    closeCIDPrinterLib() {
        throw new Error('Method not implemented.');
    }
    convert(options) {
        console.log('convert', options);
    }
    getPrinterStatus() {
        throw new Error('Method not implemented.');
    }
    setupMediaSize(options) {
        console.log('setupMediaSize', options);
    }
    enableDispendingMode(options) {
        console.log('enableDispendingMode', options);
    }
    async activateLicense(options) {
        console.log('activateLicense', options);
        throw new Error('Method not implemented.');
    }
    async enableNetworkPrinting(options) {
        console.log('enableNetworkPrinting', options);
        return { value: 'enableNetworkPrinting' };
    }
    async enableBluetoothPrinting(options) {
        console.log('enableBluetoothPrinting', options);
        return { value: 'enableBluetoothPrinting' };
    }
    async setAutoReconnect(options) {
        console.log('setAutoReconnect', options);
    }
    async setConfiguration(options) {
        console.log('setConfiguration', options);
    }
    getPairedDevices() {
        throw new Error('Method not implemented.');
    }
    discoverDevices(options) {
        console.log('discoverDevices', options);
        throw new Error('Method not implemented.');
    }
    printReferenceLabel(options) {
        console.log('printReferenceLabel', options);
    }
    async printData(options) {
        console.log('printData', options);
        return options;
    }
    async printNativeData(options) {
        console.log('printData', options);
        return options;
    }
    showUI(options) {
        console.log('showUI', options);
        throw new Error('Method not implemented.');
    }
    showSettings(options) {
        console.log('showSettings', options);
        throw new Error('Method not implemented.');
    }
    setTimeouts(options) {
        console.log('setTimeouts', options);
        throw new Error('Method not implemented.');
    }
    setLTSSensitivity(options) {
        console.log('setLTSSensitivity', options);
        throw new Error('Method not implemented.');
    }
}
// const CIDPrint = new CIDPrintWeb();
// export { CIDPrint };
//# sourceMappingURL=web.js.map